import React from 'react'
import { InlineMath, BlockMath } from 'react-katex'
import 'katex/dist/katex.min.css'

// Renderer DÙNG CHUNG cho phiên trực tiếp (màn hình GV + HS):
// hiển thị đầy đủ ẢNH, CÔNG THỨC ($...$ / $$...$$) và BẢNG markdown (| a | b |)
// — bảng do backend dựng bằng cells_to_markdown của PMaker.
const MD_ROW = /^\s*\|(.+)\|\s*$/
const isSepRow = (cells: string[]) => cells.length > 0 && cells.every((c) => /^:?-{2,}:?$/.test(c.trim()))

const renderInline = (text: string, kb: string): React.ReactNode[] =>
  text.split(/(\$\$[\s\S]+?\$\$|\$[^$]+?\$)/g).map((p, i) => {
    if (p.startsWith('$$') && p.endsWith('$$') && p.length > 4) return <BlockMath key={`${kb}-${i}`} math={p.slice(2, -2)} />
    if (p.startsWith('$') && p.endsWith('$') && p.length > 2) return <InlineMath key={`${kb}-${i}`} math={p.slice(1, -1)} />
    return <span key={`${kb}-${i}`}>{p}</span>
  })

export const renderRichContent = (s: any): React.ReactNode => {
  if (typeof s !== 'string') return s ?? null
  const t = s.trim()
  // Cả chuỗi là 1 ảnh (data:image hoặc URL ảnh)
  if (t.startsWith('data:image/') || /^https?:\/\/\S+\.(png|jpe?g|gif|webp|svg)(\?\S*)?$/i.test(t))
    return <img src={t} alt="" className="max-h-44 inline-block align-middle rounded-lg" />

  const lines = s.split('\n')
  const out: React.ReactNode[] = []
  let i = 0
  let seg = 0
  while (i < lines.length) {
    if (MD_ROW.test(lines[i])) {
      const tbl: string[] = []
      while (i < lines.length && MD_ROW.test(lines[i])) { tbl.push(lines[i]); i++ }
      const rows = tbl
        .map((l) => l.trim().replace(/^\|/, '').replace(/\|$/, '').split('|').map((c) => c.trim()))
        .filter((cells) => !isSepRow(cells))
      if (rows.length) {
        out.push(
          <div key={`tb-${seg}`} className="overflow-x-auto my-2">
            <table className="border-collapse mx-auto bg-white text-[0.95em]">
              <tbody>
                {rows.map((r, ri) => (
                  <tr key={ri}>
                    {r.map((c, ci) =>
                      React.createElement(
                        ri === 0 ? 'th' : 'td',
                        { key: ci, className: `border border-gray-400 px-3 py-1.5 text-center ${ri === 0 ? 'font-bold bg-gray-100' : ''}` },
                        renderInline(c, `c${seg}-${ri}-${ci}`),
                      )
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>,
        )
        seg++
      }
    } else {
      const txt: string[] = []
      while (i < lines.length && !MD_ROW.test(lines[i])) { txt.push(lines[i]); i++ }
      const joined = txt.join('\n')
      if (joined.trim()) { out.push(<span key={`tx-${seg}`}>{renderInline(joined, `s${seg}`)}</span>); seg++ }
    }
  }
  return out.length === 1 ? out[0] : out
}

export default renderRichContent
